import { create } from "zustand";
import type { LookupItem } from "../api/types";

export type LookupPanelRequest = {
  entity: string;
  title: string;
  lookupUrl: string;
  createModule?: string;
  searchText?: string;
  parentContext?: Record<string, unknown>;
  suppressAfterSelect?: () => void;
  returnFocus?: () => void;
  onSelect: (item: LookupItem) => void;
};

type LookupPanelState = {
  open: boolean;
  request: LookupPanelRequest | null;
  openPanel: (request: LookupPanelRequest) => void;
  closePanel: () => void;
};

export const useLookupPanelStore = create<LookupPanelState>((set) => ({
  open: false,
  request: null,
  openPanel: (request) => set({ open: true, request }),
  closePanel: () => set({ open: false, request: null })
}));
